import wildCardSearch from 'utils/wildCardSearch'

export default function projectFakeApi (server, apiPrefix) {

    server.get(`${apiPrefix}/project/dashboard`, (schema) => {
        return schema.db.projectDashboardData[0]
    })

    server.post(`${apiPrefix}/project/list`, (schema, {requestBody}) => {
        const { sort, search } = JSON.parse(requestBody)
        let data = schema.db.projectList
        if(sort === 'asc') {
            data = data.sort((a, b) => (a.name > b.name) ? 1 : -1)
        }
        if(sort === 'desc') {
            data = data.sort((a, b) => (a.name > b.name) ? -1 : 1)
        }

        if (search) {
            data = wildCardSearch(data, search)
        }

        return data
    })

    server.put(`${apiPrefix}/project/list/add`, (schema, {requestBody}) => {
        const data = JSON.parse(requestBody)
        
        schema.db.projectList.insert(data)

        return schema.db.projectList
    })
    
    server.post(`${apiPrefix}/project/scrum-board/members`, schema => {
        const borderMembersId = [ '3', '2', '5', '7', '1', '10', '9' ]
        const participantMembers = schema.db.usersData.filter(user => borderMembersId.includes(user.id))
        const allMembers = schema.db.usersData
        return {
            participantMembers,
            allMembers
        }
    })

    server.post(`${apiPrefix}/project/scrum-board/boards`, schema => {
        const data = schema.db.scrumboardData[0]
        delete data.id
        return data
    })

    server.get(`${apiPrefix}/project/scrum-board/tickets/detail`, schema => schema.db.issueData[0])

    server.post(`${apiPrefix}/accounts/projects`, (schema, {requestBody}) => {
        const data = JSON.parse(requestBody)
        data.id = Math.floor(Math.random() * 10000)
        data.project_status = data.project_status || 'in progress'
        data.editors = data.editors || []
        data.client_id__first_name = data.client_id__first_name || 'Admin'
        data.client_id__last_name = data.client_id__last_name || 'User'
        data.total_photos = data.total_photos || 0
        data.creation_date = data.creation_date || new Date().toISOString()
        
        if (data.project_name) {
            data.proj_url = data.project_name.replace(/#/g, '').replace(/\s+/g, '-').toLowerCase()
            data.name = data.project_name
        }
        schema.db.projectList.insert(data)
        return { message: 'Success', data: data }
    })

    server.put(`${apiPrefix}/accounts/projects/:id`, (schema, request) => {
        const id = request.params.id;
        const data = JSON.parse(request.requestBody);
        let project = schema.db.projectList.findBy({ proj_url: id })
        if (!project) project = schema.db.projectList.findBy({ id: id })
        
        if (project) {
            schema.db.projectList.update(project.id, { ...project, ...data });
            return { message: 'Success', data: { ...project, ...data } };
        }
        return { message: 'Failed to find project' }
    })

    server.get(`${apiPrefix}/accounts/projects/:id`, (schema, request) => {
        const id = request.params.id
        let projects = schema.db.projectList.filter(p => {
            const computedUrl = p.proj_url || (p.project_name || p.name || '').replace(/#/g, '').replace(/\s+/g, '-').toLowerCase()
            return computedUrl === id || String(p.id) === String(id)
        })
        let project = projects.length > 0 ? projects[0] : null;
        
        if (project) {
            const rawPhotos = schema.db.rawPhotosData ? schema.db.rawPhotosData.filter(r => String(r.project_id) === String(project.id)) : [];
            return {
                ...project,
                project_name: project.project_name || project.name,
                project_status: project.project_status || 'in progress',
                proj_url: project.proj_url || (project.project_name || project.name || '').replace(/#/g, '').replace(/\s+/g, '-').toLowerCase(),
                total_photos: rawPhotos.length,
                creation_date: project.creation_date || new Date().toISOString(),
                proj_deadline: project.proj_deadline || new Date(new Date().setDate(new Date().getDate() + 7)).toISOString(),
                client_id__first_name: project.client_id__first_name || 'Demo',
                client_id__last_name: project.client_id__last_name || 'Client',
                first_name: project.client_id__first_name || 'Demo',
                last_name: project.client_id__last_name || 'Client',
                editors: project.editors || project.member || [],
                client_notes: project.client_notes || 'These are dummy client notes added for the project.',
                instructions: project.instructions || 'These are dummy instructions added for the project.'
            }
        }
        return {}
    })

    server.get(`${apiPrefix}/accounts/projects`, (schema) => {
        const projects = schema.db.projectList.map(p => {
            const rawPhotos = schema.db.rawPhotosData ? schema.db.rawPhotosData.filter(r => String(r.project_id) === String(p.id)) : [];
            return {
                ...p,
                project_name: p.project_name || p.name,
                project_status: p.project_status || 'in progress',
                proj_url: p.proj_url || (p.project_name || p.name || '').replace(/#/g, '').replace(/\s+/g, '-').toLowerCase(),
                total_photos: rawPhotos.length,
                creation_date: p.creation_date || new Date().toISOString(),
                proj_deadline: p.proj_deadline || new Date(new Date().setDate(new Date().getDate() + 7)).toISOString(),
                client_id__first_name: p.client_id__first_name || 'Demo',
                client_id__last_name: p.client_id__last_name || 'Client',
                client_id__middle_name: p.client_id__middle_name || '',
                client_id__suffix_name: p.client_id__suffix_name || '',
                editors: p.editors || p.member || [],
                client_notes: p.client_notes || 'These are dummy client notes added for the project.',
                instructions: p.instructions || 'These are dummy instructions added for the project.'
            };
        })
        return projects
    })

    server.post(`${apiPrefix}/accounts/get_projects`, (schema, {requestBody}) => {
        const projects = schema.db.projectList.filter(p => p.project_status !== 'archived').map(p => {
            const rawPhotos = schema.db.rawPhotosData ? schema.db.rawPhotosData.filter(r => String(r.project_id) === String(p.id)) : [];
            return {
                ...p,
                project_name: p.project_name || p.name,
                project_status: p.project_status || 'in progress',
                proj_url: p.proj_url || (p.project_name || p.name || '').replace(/#/g, '').replace(/\s+/g, '-').toLowerCase(),
                total_photos: rawPhotos.length,
                creation_date: p.creation_date || new Date().toISOString(),
                proj_deadline: p.proj_deadline || new Date(new Date().setDate(new Date().getDate() + 7)).toISOString(),
                client_id__first_name: p.client_id__first_name || 'Demo',
                client_id__last_name: p.client_id__last_name || 'Client',
                client_id__middle_name: p.client_id__middle_name || '',
                client_id__suffix_name: p.client_id__suffix_name || '',
                editors: p.editors || p.member || [],
                client_notes: p.client_notes || 'These are dummy client notes added for the project.',
                instructions: p.instructions || 'These are dummy instructions added for the project.'
            };
        })
        return { data: projects, total: projects.length }
    })

    server.put(`${apiPrefix}/accounts/get_projects`, (schema, {requestBody}) => {
        const { project_id } = JSON.parse(requestBody)
        if (project_id) {
            schema.db.projectList.update(project_id, { project_status: 'archived' });
        }
        return { message: 'Success' }
    })

    server.del(`${apiPrefix}/accounts/get_projects`, (schema, {requestBody}) => {
        const { project_id } = JSON.parse(requestBody)
        if (project_id) {
            schema.db.projectList.remove(project_id)
        }
        return { message: 'Success' }
    })

    // Mock Product, Raw, and Folder Endpoints to allow temporary data creation
    server.post(`${apiPrefix}/accounts/projects/:id/raw`, (schema, request) => { 
        const id = request.params.id;
        const newPhoto = {
            id: Math.floor(Math.random() * 10000),
            project_id: parseInt(id),
            uploaded_file: '/img/products/product-8.jpg',
            size: 15000,
            third_party_url: ''
        };
        schema.db.rawPhotosData.insert(newPhoto);
        return { message: 'Success', data: newPhoto } 
    })
    server.put(`${apiPrefix}/accounts/projects/:id/raw`, () => { return { message: 'Success', data: {} } })
    server.get(`${apiPrefix}/accounts/projects/:id/raw`, (schema, request) => { 
        const id = request.params.id;
        const rawPhotos = schema.db.rawPhotosData ? schema.db.rawPhotosData.filter(r => String(r.project_id) === String(id)) : [];
        const totalSize = rawPhotos.reduce((sum, r) => sum + (r.size || 0), 0);
        
        return { 
            message: 'Success', 
            data: rawPhotos,
            page_number: 1,
            next_page: null,
            total_images: rawPhotos.length,
            total_size: totalSize
        } 
    })
    
    server.post(`${apiPrefix}/accounts/projects/:folder/output`, (schema, request) => { 
        const folderId = request.params.folder;
        const newFile = {
            id: Math.floor(Math.random() * 10000),
            folder_id: parseInt(folderId),
            uploaded_file: '/img/products/product-7.jpg',
            size: 21200,
            third_party_url: ''
        };
        schema.db.productFilesData.insert(newFile);
        return { message: 'Success', data: newFile } 
    })
    server.get(`${apiPrefix}/accounts/projects/:id/output`, (schema, request) => { 
        const folderId = request.params.id;
        const files = schema.db.productFilesData ? schema.db.productFilesData.filter(f => String(f.folder_id) === String(folderId)) : [];
        const totalSize = files.reduce((sum, f) => sum + (f.size || 0), 0);
        return { 
            message: 'Success', 
            data: files,
            page_number: 1,
            next_page: null,
            total_images: files.length,
            total_size: totalSize
        } 
    })
    
    server.post(`${apiPrefix}/accounts/projects/:id/folders`, (schema, request) => { 
        const id = request.params.id;
        const data = JSON.parse(request.requestBody || '{}');
        const newFolder = {
            id: Math.floor(Math.random() * 10000),
            project_id: parseInt(id),
            foldername: data.foldername || 'New Folder',
            invoice_status: 'pending'
        };
        schema.db.productFoldersData.insert(newFolder);
        return { message: 'Success', data: newFolder } 
    })
    server.get(`${apiPrefix}/accounts/projects/:id/folders`, (schema, request) => { 
        const id = request.params.id;
        const folders = schema.db.productFoldersData ? schema.db.productFoldersData.filter(f => String(f.project_id) === String(id)) : [];
        return { 
            message: 'Success', 
            data: folders 
        } 
    })
    
    server.del(`${apiPrefix}/accounts/projects/:id/raw/:uploaded_id`, () => { return { message: 'Success', data: {} } })
    server.del(`${apiPrefix}/accounts/projects/:folder/output/:uploaded_id`, () => { return { message: 'Success', data: {} } })
    
    server.post(`${apiPrefix}/accounts/projects/:id/comments`, () => { return { message: 'Success', data: {} } })
    server.get(`${apiPrefix}/accounts/projects/:id/comments`, (schema, request) => { 
        return { 
            message: 'Success', 
            data: [
                {
                    id: 1,
                    user_id__first_name: 'Admin',
                    user_id__last_name: 'User',
                    user_id__authority: 'ADMIN',
                    user_id__thumbnail: '',
                    comment_date: new Date(Date.now() - 86400000).toISOString(),
                    comments: 'This is a dummy comment for project ' + request.params.id,
                    attachments: []
                },
                {
                    id: 2,
                    user_id__first_name: 'Demo',
                    user_id__last_name: 'Client',
                    user_id__authority: 'USER',
                    user_id__thumbnail: '',
                    comment_date: new Date(Date.now() - 3600000).toISOString(),
                    comments: 'Please make sure to review the requirements.',
                    attachments: []
                }
            ] 
        } 
    })

    server.post(`${apiPrefix}/accounts/projects/change-progress/:id`, () => { return { message: 'Success', data: {} } })

    server.get(`${apiPrefix}/accounts/projects/:id/editors`, (schema, request) => {
        const id = request.params.id
        let projects = schema.db.projectList.filter(p => {
            const computedUrl = p.proj_url || (p.project_name || p.name || '').replace(/#/g, '').replace(/\s+/g, '-').toLowerCase()
            return computedUrl === id || String(p.id) === String(id)
        })
        let project = projects.length > 0 ? projects[0] : null;

        let assignedMembers = [];
        let unassignedMembers = [];
        if (project) {
            const members = project.editors || project.member || [];
            assignedMembers = members.map((m, idx) => {
                const nameParts = (m.name || '').split(' ');
                const originalUser = (schema.db.usersData || []).find(u => u.name === m.name);
                return {
                    id: originalUser ? originalUser.id : (idx + 100),
                    first_name: nameParts[0] || 'Unknown',
                    middle_name: '',
                    last_name: nameParts.slice(1).join(' '),
                    thumbnail: m.img || ''
                }
            });
            
            const allUsers = schema.db.usersData || [];
            unassignedMembers = allUsers.filter(u => !members.some(m => m.name === u.name)).map(u => {
                const nameParts = (u.name || '').split(' ');
                return {
                    id: u.id,
                    first_name: nameParts[0] || 'Unknown',
                    middle_name: '',
                    last_name: nameParts.slice(1).join(' '),
                    thumbnail: u.img || ''
                }
            });
        }

        return { assignedMembers, unassignedMembers }
    })

    server.post(`${apiPrefix}/accounts/projects/:id/editors`, (schema, request) => {
        const id = request.params.id
        const { editor_id } = JSON.parse(request.requestBody)
        let projects = schema.db.projectList.filter(p => {
            const computedUrl = p.proj_url || (p.project_name || p.name || '').replace(/#/g, '').replace(/\s+/g, '-').toLowerCase()
            return computedUrl === id || String(p.id) === String(id)
        })
        let project = projects.length > 0 ? projects[0] : null;

        if (project) {
            const allUsers = schema.db.usersData || [];
            const editorToAdd = allUsers.find(u => String(u.id) === String(editor_id));
            if (editorToAdd) {
                let members = project.editors || project.member || [];
                // Check if already exists
                if (!members.some(m => m.name === editorToAdd.name)) {
                    members = [...members, { name: editorToAdd.name, img: editorToAdd.img }];
                    schema.db.projectList.update(project.id, { editors: members, member: members });
                }
            }
        }
        
        // Re-calculate to return the updated lists
        let assignedMembers = [];
        let unassignedMembers = [];
        if (project) {
            const updatedProject = schema.db.projectList.find(project.id);
            const members = updatedProject.editors || updatedProject.member || [];
            assignedMembers = members.map((m, idx) => {
                const nameParts = (m.name || '').split(' ');
                const originalUser = (schema.db.usersData || []).find(u => u.name === m.name);
                return {
                    id: originalUser ? originalUser.id : (idx + 100),
                    first_name: nameParts[0] || 'Unknown',
                    middle_name: '',
                    last_name: nameParts.slice(1).join(' '),
                    thumbnail: m.img || ''
                }
            });
            const allUsers = schema.db.usersData || [];
            unassignedMembers = allUsers.filter(u => !members.some(m => m.name === u.name)).map(u => {
                const nameParts = (u.name || '').split(' ');
                return {
                    id: u.id,
                    first_name: nameParts[0] || 'Unknown',
                    middle_name: '',
                    last_name: nameParts.slice(1).join(' '),
                    thumbnail: u.img || ''
                }
            });
        }
        return { assignedMembers, unassignedMembers }
    })

    server.del(`${apiPrefix}/accounts/projects/:id/editors`, (schema, request) => {
        const id = request.params.id
        const { editor_id } = JSON.parse(request.requestBody)
        let projects = schema.db.projectList.filter(p => {
            const computedUrl = p.proj_url || (p.project_name || p.name || '').replace(/#/g, '').replace(/\s+/g, '-').toLowerCase()
            return computedUrl === id || String(p.id) === String(id)
        })
        let project = projects.length > 0 ? projects[0] : null;

        if (project) {
            const allUsers = schema.db.usersData || [];
            const editorToRemove = allUsers.find(u => String(u.id) === String(editor_id));
            if (editorToRemove) {
                let members = project.editors || project.member || [];
                members = members.filter(m => m.name !== editorToRemove.name);
                schema.db.projectList.update(project.id, { editors: members, member: members });
            }
        }
        
        // Re-calculate to return the updated lists
        let assignedMembers = [];
        let unassignedMembers = [];
        if (project) {
            const updatedProject = schema.db.projectList.find(project.id);
            const members = updatedProject.editors || updatedProject.member || [];
            assignedMembers = members.map((m, idx) => {
                const nameParts = (m.name || '').split(' ');
                const originalUser = (schema.db.usersData || []).find(u => u.name === m.name);
                return {
                    id: originalUser ? originalUser.id : (idx + 100),
                    first_name: nameParts[0] || 'Unknown',
                    middle_name: '',
                    last_name: nameParts.slice(1).join(' '),
                    thumbnail: m.img || ''
                }
            });
            const allUsers = schema.db.usersData || [];
            unassignedMembers = allUsers.filter(u => !members.some(m => m.name === u.name)).map(u => {
                const nameParts = (u.name || '').split(' ');
                return {
                    id: u.id,
                    first_name: nameParts[0] || 'Unknown',
                    middle_name: '',
                    last_name: nameParts.slice(1).join(' '),
                    thumbnail: u.img || ''
                }
            });
        }
        return { assignedMembers, unassignedMembers }
    })

    server.get(`${apiPrefix}/notification/count`, () => {
        return { count: 0 }
    })

    server.post(`${apiPrefix}/editors/`, (schema) => {
        const allUsers = schema.db.usersData || [];
        const mockEditors = allUsers.map((user, index) => {
            const nameParts = (user.name || '').split(' ');
            return {
                id: user.id || index + 1,
                first_name: nameParts[0] || 'Unknown',
                middle_name: '',
                last_name: nameParts.slice(1).join(' '),
                gender: index % 2 === 0 ? 'Female' : 'Male', // Mock gender
                age: 25 + (index % 15), // Mock age
                address: `${100 + index} Mock St, City, ST`, // Mock address
                img: user.img || ''
            };
        });
        return { data: mockEditors, total: mockEditors.length }
    })

    server.get(`${apiPrefix}/accounts/products/`, () => {
        return {
            message: 'Success',
            data: [
                { id: 1, product_name: 'Basic Photo Retouching', product_category: 1, product_price: 5.00 },
                { id: 2, product_name: 'Advanced Photo Manipulation', product_category: 1, product_price: 15.00 },
                { id: 3, product_name: 'Real Estate HDR Blending', product_category: 1, product_price: 3.50 },
                { id: 4, product_name: 'Video Color Grading', product_category: 2, product_price: 25.00 },
                { id: 5, product_name: 'Short Form Video Edit', product_category: 2, product_price: 15.00 },
                { id: 6, product_name: 'Full Event Video Edit', product_category: 2, product_price: 150.00 }
            ]
        }
    })
}